import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NhanVien } from '../nhan-su/nhan-su.component';

@Injectable({
  providedIn: 'root'
})
export class NhanSuService {

  constructor(private httpClient: HttpClient) { }

  changePassword(oldPassword: string, newPassword: string, idUser: number) {
    return this.httpClient.get('/api/Nhanviens/ChangePassword?oldPassword=' + oldPassword
      + '&newPassword=' + newPassword + '&idUser=' + idUser);
  }

  setPassword(newPassword: string, idUser: number) {
    return this.httpClient.get('/api/Nhanviens/SetPassword?newPassword=' + newPassword + '&idUser=' + idUser);
  }

  checkUser(loginData: any) {
    return this.httpClient.post('/api/Nhanviens/CheckUser', loginData);
  }

  getAllCongChungVien() {
    return this.httpClient.get('/api/Nhanviens/GetAllCongChungVien');
  }

  getAllNhanVien() {
    return this.httpClient.get('/api/Nhanviens/GetAllNhanVien');
  }

  findNhanSu(findValue: string, limit: number, pageNumber: number): any {
    return this.httpClient.get('/api/Nhanviens/FindNhanVien?searchValue=' + findValue + '&pageSize=' + limit + '&pageNumber=' + pageNumber);
  }

  findCongChungVien(findValue: string, limit: number, pageNumber: number): any {
    return this.httpClient.get('/api/Nhanviens/FindCongChungVien?searchValue=' + findValue + '&pageSize=' + limit + '&pageNumber=' + pageNumber);
  }

  findNotCongChungVien(findValue: string, limit: number, pageNumber: number): any {
    return this.httpClient.get('/api/Nhanviens/FindNotCongChungVien?searchValue=' + findValue + '&pageSize=' + limit + '&pageNumber=' + pageNumber);
  }

  getNhanSuById(id: number): any {
    return this.httpClient.get('/api/Nhanviens/' + id);
  }

  update(id: number, hoVaTen: string, laCongChungVien: number, username: string, quyen: number, tinhtrang: number, password: string): any {
    const dataPost = {
      id: id,
      hovaten: hoVaTen,
      lacongchungvien: laCongChungVien,
      quyen: quyen,
      username: username,
      tinhtrang: tinhtrang,
      password: password
    };
    return this.httpClient.put('/api/Nhanviens/' + id, dataPost);
  }

  add(data: any): any {
    return this.httpClient.post('/api/Nhanviens/', data);
  }

  delete(id: number): any {
    return this.httpClient.delete('/api/Nhanviens/' + id);
  }

  count() {
    return this.httpClient.get('/api/Nhanviens/Count');
  }
}
